import { render, staticRenderFns } from "./QuoteImages.vue?vue&type=template&id=a72c4ad6"
import script from "./QuoteImages.vue?vue&type=script&lang=js"
export * from "./QuoteImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports